import { Component, OnInit } from '@angular/core';
import { NofeshService } from 'app/nofesh/nofesh.service';
import { Router } from '@angular/router';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';
import { ConfigService } from 'app/shared/config.service';
import { INofesh } from 'app/nofesh/model/nofesh';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { ENofeshType } from 'app/shared/enums/enofesh-type.enum';
import { FavoritesNofashimService } from '../favorites-nofashim.service';


@Component({
  selector: 'app-select-nofashim',
  templateUrl: './select-nofashim.component.html',
  styleUrls: ['./select-nofashim.component.css']
})
export class SelectNofashimComponent implements OnInit {

  constructor(
    private _http: NofeshService, 
    private _router: Router,
    private userMessagesService: UserMessagesService,
    private _configService : ConfigService,
    private _userMessages : UserMessagesService,
    private _favoritesService: FavoritesNofashimService
) 
{
    this.apiUrl = _configService.getConfigPropertyByKey("apiUrl");
}
apiUrl: string = "";

nofashim: INofesh[];
nofesh_syllabus_file_url: string =  `${this.apiUrl}/UploadFiles/NofeshSyllabus/`
selected_nofesh_id: number;

nofesh_meurganim: INofesh[];
nofshonim: INofesh[];
nofesh_baaretz: INofesh[];
mishpachotChul: INofesh[];
generalFullListNofashim: INofesh[] =[];
favoritesNofashim: INofesh[] = [];
topThreeFavoritesNofashim: INofesh[] = [];

ngOnInit(): void {
    
    this._userMessages.clearAll();
    let url: string  = `${this.apiUrl}/`
   // localStorage.setItem("should_load_captcha", "true");
    
    this._http.getAllNofashim()
        .subscribe((response: ResultOfOperation<INofesh[]>) => {
            if(response.isSuccess)
            {
              Object.assign(this.favoritesNofashim,response.data);   
              Object.assign(this.generalFullListNofashim,response.data);    
              
                let data: INofesh[] = response.data;
                this.nofashim = data.filter(n => n.k_pail > 0);
                if(this.nofashim.length > 0)
                {
                    this.nofesh_meurganim = this.nofashim.filter(t => t.nofeshType == ENofeshType.MeurganimChul);
                    this.nofshonim = this.nofashim.filter(t => t.nofeshType == ENofeshType.NofeshChul);
                    this.nofesh_baaretz = this.nofashim.filter(t => t.nofeshType == ENofeshType.NofeshPnim);
                    this.mishpachotChul = this.nofashim.filter(nofesh => nofesh.nofeshType == ENofeshType.MishpachotChul)
                    // Put the object into storage
                    sessionStorage.setItem('nofashim', JSON.stringify(data));


                    this._http.getFavoritesNofashim().subscribe(result => {
                        console.log(result.data)
                        console.log('this.favoritesNofashim before filter',this.favoritesNofashim);
                        this.favoritesNofashim = this.favoritesNofashim.filter(n=>n.id_nofesh == result.data.id_nofesh_1 || n.id_nofesh == result.data.id_nofesh_2 || n.id_nofesh == result.data.id_nofesh_3);
                        console.log('favoritesNofashim',this.favoritesNofashim);
                    })


                }
                else
                {
                    this.userMessagesService.setErrorMessage("אין נופשים להצגה");
                }
            }
            else
            {
                this.userMessagesService.setErrorMessage(response.message);
            }
        }, error => {
            console.log(error);
            if (error.status == 401) {
                localStorage.removeItem("token");
                location.reload();
            }
        });

       
        
}

nofeshDetails(event, nofeshId: number, nofeshType: number): void {
    event.preventDefault();
   
    if(nofeshType == ENofeshType.MeurganimChul)
    {
        this._router.navigate(['nofesh/nofesh-details/' + nofeshId]);
    }
    else if(nofeshType == ENofeshType.NofeshChul)
    {
        this._router.navigate(['nofshonim-chul/nofesh-details/' + nofeshId]);
    }
    else if(nofeshType == ENofeshType.MishpachotChul)
    {
        /*
        let selectedNofesh: INofesh = this.nofashim.find(n => n.id_nofesh == nofeshId);
        sessionStorage.setItem("nofesh", JSON.stringify(selectedNofesh));
        */
        this._router.navigate([`mishpachot-chul/nofesh-details/${nofeshId}`]);
    }
    else if(nofeshType == ENofeshType.NofeshPnim)
    {
        //nofesh baretz
        this._router.navigate(['nofesh-pnim/nofesh-details/' + nofeshId]);
    }
}

onNofeshSelected(id_nofesh: number) {
    this.selected_nofesh_id = id_nofesh;
}

redirectToLogin(){
    this._router.navigate(['/login'], {queryParams: {nav: 'nofesh'}});
}

addToFavorites(event, id_nofesh: number)
{
  let isNofeshExists: boolean = false;
  let localFavoritesNofashim : INofesh[] = [];
  Object.assign(localFavoritesNofashim,this.generalFullListNofashim);    
  localFavoritesNofashim = localFavoritesNofashim.filter(res=>res.id_nofesh == id_nofesh)

  this.favoritesNofashim.forEach(nofesh => {
    if(nofesh.id_nofesh == id_nofesh)
    {
      isNofeshExists = true;
    }
  });
  if(isNofeshExists)
  {
    return;
  }
  if(this.favoritesNofashim.length == 3)
  {
    this._userMessages.setErrorMessage("לא ניתן להוסיף יותר משלושה נופשים מועדפים");
    return;
  }
  else
  {
    this.favoritesNofashim.push(localFavoritesNofashim[0]); 
    this._userMessages.clearAll(); 
  }
}

removeFavoriteNofesh(event, id_nofesh: number)
{
  this.favoritesNofashim = this.favoritesNofashim.filter (res=>res.id_nofesh !== id_nofesh);
  this._userMessages.clearAll(); 
}

saveFavoriteNofashim()
{
   this._favoritesService.updateFavoritesNofashim(this.favoritesNofashim).subscribe(res =>{
     if(res.isSuccess)
     {
       this._userMessages.setSuccessMessage("הנופשים המועדפים נשמרו בהצלחה. הנופשים יופיעו בראש העמוד בזמן הרישום");
     }
     else
     {
       this._userMessages.setErrorMessage("בעיה בשמירת הנופשים המועדפים. אנא נסו מאוחר יותר")
       console.log('res',res)
     }
   },error=>{
    this._userMessages.setErrorMessage("בעיה בשמירת הנופשים המועדפים. אנא פנו למנהל המערכת")
   })
}

}
